import { useTranslation } from 'react-i18next';
import type { AuditEntry } from '@worki/shared';
import { currentLocale } from '../i18n.js';
import { formatRelative } from '../lib/format.js';
import { actorName } from '../lib/actorName.js';

/**
 * One entry of the audit log as a line of the feed: what happened, then who
 * did it and when.
 *
 * It was the dashboard's "recent activity" row until that block moved into the
 * notifications and reminders screen (1.15). Not a button, like the log it
 * draws: an entry has nothing to open, edit or delete.
 */
export function ActivityRow({ entry }: { entry: AuditEntry }) {
  const { t } = useTranslation();
  const locale = currentLocale();

  return (
    <div className="list-tint rounded-xl border border-border/60 bg-card px-4 py-3 flex items-start gap-3">
      <span className="mt-1.5 h-2 w-2 rounded-full bg-primary/60 shrink-0" aria-hidden />
      <div className="min-w-0">
        {/* `summary` is an i18n key produced by the audit log. */}
        <p className="text-sm truncate">{t(entry.summary, { defaultValue: entry.action })}</p>
        <p className="text-xs text-muted-foreground">
          {/* System actors are stored in English by design. */}
          {actorName(entry.actorLabel, t)} · {formatRelative(entry.createdAt, locale)}
        </p>
      </div>
    </div>
  );
}
